export default {"src":"/_next/static/media/Maine.66e1cb09.svg","height":867,"width":800,"blurWidth":0,"blurHeight":0};